import workspaceIntroRule from './workspaceIntroRule';

export default {
    name: 'workspaceIntroduction',
    priority: 500,
    rule: () => workspaceIntroRule(),
    action: () => () => {
        import(/* webpackChunkName: "workspaceIntroModalAction" */
        './workspaceIntroAction').then(({ default: action }) => action());
    },
};
